export default __webpack_public_path__ + "static/media/format_list_bulleted.817064e7.svg";